<div class="flex flex-row justify-start items-center md:justify-between md:items-center w-full">
  <div class="flex flex-row space-x-0 md:space-x-3 justify-start items-center">
    <div class="flex flex-row justify-start items-center space-x-0 md:space-x-2 w-24">
      <button hlmBtn variant="ghost" size="icon-sm" (click)="calendarService.calendarNav.next('prev')">
        <lucide-icon [img]="ChevronLeft" [size]="20"></lucide-icon>
      </button>
      <button hlmBtn variant="ghost" size="icon-sm" (click)="calendarService.calendarNav.next('next')">
        <lucide-icon [img]="ChevronRight" [size]="20"></lucide-icon>
      </button>
    </div>

    <div class="flex flex-row space-x-0 md:space-x-1 justify-start items-center flex-grow md:flex-auto text-primary">
      <h5 style="white-space: nowrap;" class="text-xs md:text-base font-medium">{{ (calendarService.currentDate | async) | date:'EEEE, d. MMMM yyyy' }}</h5>
      <hlm-popover>
        <button hlmPopoverTrigger hlmBtn variant="ghost" size="icon-sm">
          <lucide-icon [img]="ChevronDown" [size]="20"></lucide-icon>
        </button>
        <hlm-popover-content *hlmPopoverPortal class="!w-auto !p-0">
          <hlm-calendar
            [weekStartsOn]="1"
            [date]="(calendarService.currentDate | async)!"
            (dateChange)="onDateSelected($event)"
            calendarClass="border-0"
          ></hlm-calendar>
        </hlm-popover-content>
      </hlm-popover>
    </div>

    <button hlmBtn variant="outline" size="sm" class="border-gray-200" (click)="calendarService.calendarNav.next('today')">Heute</button>
  </div>

  <div class="flex md:visible flex-1"></div>

  <!-- Mobile menu -->
  <button hlmBtn variant="ghost" size="icon-sm" [hlmDropdownMenuTrigger]="mobileMenu" class="visible md:invisible">
    <lucide-icon [img]="EllipsisVertical" [size]="20"></lucide-icon>
  </button>
  <ng-template #mobileMenu>
    <div hlmDropdownMenu>
      <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridWeek')">
        Woche (Mo-So)
      </button>
      <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridWorkweek')">
        Woche (Mo-Fr)
      </button>
      <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridDay')">
        Tag
      </button>
      <button hlmDropdownMenuItem routerLink="/termine">
        Liste
      </button>
      <div hlmDropdownMenuSeparator class="visible md:invisible"></div>
      <div class="flex flex-row justify-between items-center h-12 w-full px-2 md:invisible">
        <div class="flex flex-col justify-center items-center w-1/3 cursor-pointer" (click)="onUpdateCalendarSize('plus')">
          <lucide-icon [img]="Minus" [size]="20"></lucide-icon>
        </div>
        <div class="flex flex-col justify-center items-center w-1/3 cursor-default">
          <h5 class="m-0 font-medium">{{ calendarZoomLabel }}</h5>
        </div>
        <div class="flex flex-col justify-center items-center w-1/3 cursor-pointer" (click)="onUpdateCalendarSize('minus')">
          <lucide-icon [img]="Plus" [size]="20"></lucide-icon>
        </div>
      </div>
      <div hlmDropdownMenuSeparator class="block md:hidden"></div>
      <div class="flex flex-col p-1 space-y-2.5 md:hidden">
        <h5 class="m-0 font-medium">Gruppen</h5>
        <app-list-booking-groups
          (handleBgClick)="calendarService.displayBookingGroupInCalendar($event)">
        </app-list-booking-groups>
        <div hlmDropdownMenuSeparator></div>
        <h5 class="m-0 font-medium">Profile</h5>
        <app-list-booking-profiles
          (handleBpClick)="calendarService.displayBookingProfileInCalendar($event)">
        </app-list-booking-profiles>
        <div hlmDropdownMenuSeparator></div>
        <h5 class="m-0 font-medium">Ressourcen</h5>
        <app-list-resources-as-bookingprofiles
          (handleResourceClick)="calendarService.displayResourceInCalendar($event)"
          (handleCategoryClick)="calendarService.displayResourceCategoryInCalendar($event)">
        </app-list-resources-as-bookingprofiles>
      </div>
    </div>
  </ng-template>

  <!-- Desktop controls -->
  <div class="pr-2.5 justify-end items-center flex-auto gap-2.5 hidden sm:flex">
    <!-- Zoom controls -->
    <div class="flex flex-row h-8 items-center border border-gray-200 rounded-md overflow-hidden">
      <button hlmBtn variant="ghost" size="icon-sm" class="rounded-none border-r border-gray-200" (click)="onUpdateCalendarSize('plus')">
        <lucide-icon [img]="Minus" [size]="16"></lucide-icon>
      </button>
      <div class="w-10 flex items-center justify-center cursor-default">
        <span class="text-sm font-medium">{{ calendarZoomLabel }}</span>
      </div>
      <button hlmBtn variant="ghost" size="icon-sm" class="rounded-none border-l border-gray-200" (click)="onUpdateCalendarSize('minus')">
        <lucide-icon [img]="Plus" [size]="16"></lucide-icon>
      </button>
    </div>

    <!-- Booking profiles dropdown -->
    <button hlmBtn variant="outline" size="sm" class="border-gray-200" [hlmDropdownMenuTrigger]="bpMenu">
      <span class="flex flex-row justify-center items-center gap-1">
        <span class="invisible lg:visible">Buchungsprofile</span>
        <span class="visible lg:invisible">BPs</span>
      </span>
      <lucide-icon [img]="ChevronDown" [size]="16"></lucide-icon>
    </button>
    <ng-template #bpMenu>
      <div hlmDropdownMenu class="min-w-[220px]">
        <div class="flex flex-col space-y-2.5 p-2">
          <h5 class="m-0 text-sm font-medium">Gruppen</h5>
          <app-list-booking-groups
            (handleBgClick)="calendarService.displayBookingGroupInCalendar($event)">
          </app-list-booking-groups>
          <div hlmDropdownMenuSeparator></div>
          <h5 class="m-0 text-sm font-medium">Profile</h5>
          <app-list-booking-profiles
            (handleBpClick)="calendarService.displayBookingProfileInCalendar($event)">
          </app-list-booking-profiles>
        </div>
      </div>
    </ng-template>

    <!-- View selector dropdown -->
    <button hlmBtn variant="outline" size="sm" class="border-gray-200" [hlmDropdownMenuTrigger]="viewMenu">
      @if (calendarService.currentView | async; as currentView) {
        <span>{{ viewLabel[currentView] }}</span>
      } @else {
        <span>{{ viewLabel[calendarService.getStorageCalendarSetting('defaultView')] }}</span>
      }
      <lucide-icon [img]="ChevronDown" [size]="16"></lucide-icon>
    </button>
    <ng-template #viewMenu>
      <div hlmDropdownMenu>
        <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridWeek')">
          Woche (Mo-So)
        </button>
        <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridWorkweek')">
          Woche (Mo-Fr)
        </button>
        <button hlmDropdownMenuItem (click)="calendarService.updateView('resourceTimeGridDay')">
          Tag
        </button>
        <button hlmDropdownMenuItem routerLink="/termine">
          Liste
        </button>
      </div>
    </ng-template>

    <!-- Settings dropdown -->
    <button hlmBtn variant="ghost" size="icon-sm" [hlmDropdownMenuTrigger]="settingsMenu">
      <lucide-icon [img]="Settings" [size]="20"></lucide-icon>
    </button>
    <ng-template #settingsMenu>
      <div hlmDropdownMenu>
        <button hlmDropdownMenuItem (click)="calendarService.handleCalendarPrint.emit(1)">
          Drucken
        </button>

        <button hlmDropdownMenuItem (click)="openUpdateBookingTimeDialog()">
          unreg. Buchungszeiten
        </button>

        @if (calendarService.getStorageCalendarSetting('letEventDragBetweenResources')) {
          <button hlmDropdownMenuItem (click)="onToggleUpdateBetweenResources(false)">
            Termine verschieben
          </button>
        }

        @if (!calendarService.getStorageCalendarSetting('letEventDragBetweenResources')) {
          <button hlmDropdownMenuItem (click)="onToggleUpdateBetweenResources(true)">
            Termine verschieben
          </button>
        }

        <button hlmDropdownMenuItem (click)="onToggleIgnoreRulesForQuickEdit()">
          Kunden benachrichtigen: {{ calendarService.getStorageCalendarSetting('ignoreRulesForQuickEdit') ? 'aus' : 'an' }}
        </button>

        <button hlmDropdownMenuItem (click)="openReorderDialog()">
          Reihenfolge
        </button>

        <div hlmDropdownMenuSeparator></div>

        <button hlmDropdownMenuItem (click)="openCalendarSettingsDialog()">
          Sonstige Einstellungen
        </button>
      </div>
    </ng-template>
  </div>
</div>
